import {useEffect, useRef, useState} from "react";

export default function useIsInView() {
    const ref = useRef(null);
    const [isInView, setIsInView] = useState(false);

    useEffect(() => {
        if (!ref.current) return;
        const element = ref.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsInView(entry.isIntersecting);
                if (entry.isIntersecting) observer.unobserve(element);
            },
            {threshold: 0.1}
        );

        observer.observe(element);

        return () => {
            if (!element) return;

            observer.unobserve(element);
        };
    }, [ref]);

    return [ref, isInView];
}
